import {

  urlListarRenovaciones,
  urlListarRenovacion,
  urlExportarExcel,
  ambiente,
  urlGuardarFacturacionPymesRenovacion
} from "../api/urls";
import { createAction } from "redux-actions";
import moment from "moment";
import { apiGet, apiPost2 } from "../../../api";
import { ESTADOS_RENOVACION, PRODUCTOS, COMENTARIO_LOB, COMENTARIO_LOB_BLOQUEADOS } from "../constants/enums";
import { httpClient } from "../../../api/httpClient";
import { formatearNumero } from "../utils/parsearNumeros";
import { urlListarCarrito } from "../../../constants/urls";





//renovaciones
export const LISTA_RENOVACIONES_HAS_ERRORED = "LISTA_RENOVACIONES_HAS_ERRORED";
export const SET_DATA_LISTA_RENOVACIONES = "SET_DATA_LISTA_RENOVACIONES";
export const SET_DATA_LISTA_ESTADOS = "SET_DATA_LISTA_ESTADOS";
export const LISTA_RENOVACIONES_LOADING = "LISTA_RENOVACIONES_LOADING";
export const LIMPIAR_DATOS_LISTA_RENOVACIONES = "LIMPIAR_DATOS_LISTA_RENOVACIONES";
export const SET_RENOVACION_SELECCIONADA = "SET_RENOVACION_SELECCIONADA";

export const limpiarListaRenovaciones = createAction(LIMPIAR_DATOS_LISTA_RENOVACIONES);
export const setListaRenovaciones = createAction(SET_DATA_LISTA_RENOVACIONES);
export const setListaEstados = createAction(SET_DATA_LISTA_ESTADOS);
export const listaRenovacionesHasErrored = createAction(LISTA_RENOVACIONES_HAS_ERRORED);
export const listaRenovacionesIsLoading = createAction(LISTA_RENOVACIONES_LOADING);
export const setRenovacionSeleccionada = createAction(SET_RENOVACION_SELECCIONADA);


const fechaActual = moment().add(0, 'days').startOf('day');



function convertirTimestampAFecha(fecha) {
  // Convertir el timestamp de milisegundos a segundos
  const timestampInSeconds = Math.floor(fecha / 1000);

  // Crear un objeto de fecha desde el timestamp
  const fechaObj = new Date(timestampInSeconds * 1000);

  // Establecer la zona horaria en UTC y ajustar la hora a las 23:59:59
  fechaObj.setUTCHours(23, 59, 59, 0);

  // Formatear la fecha a 'Y-m-d H:i:s'
  const año = fechaObj.getUTCFullYear();
  const mes = String(fechaObj.getUTCMonth() + 1).padStart(2, '0'); // Mes empieza en 0
  const día = String(fechaObj.getUTCDate()).padStart(2, '0');
  const horas = String(fechaObj.getUTCHours()).padStart(2, '0');
  const minutos = String(fechaObj.getUTCMinutes()).padStart(2, '0');
  const segundos = String(fechaObj.getUTCSeconds()).padStart(2, '0');

  return `${año}-${mes}-${día} ${horas}:${minutos}:${segundos}`;
}

export const transformarRenovacion = (renovacion, filtros, filtrosPymes) => {

  let datos = []

  datos.push(renovacion)

  return transformarDatos(datos, filtros, filtrosPymes)[0]
}

// Obtiene la información de una renovación por el idCarrito
export const obtenerRenovacionPorIdCarrito = async (idCarrito, params, filtros = {}, ramo = 'VEHÍCULOS') => {
  // Construye la URL de búsqueda usando el idCarrito
  const url = `${urlListarRenovaciones}${params}&ambiente=${ambiente}&ramo=${ramo}`;
  try {
    const data = await httpClient.post(url,
      {
        "rangoFecha": null,
        "filtrosAtributos": {
          "reIdCarrito": idCarrito
        }
      }

    );
    if (data && data.arrayrenovaciones && data.arrayrenovaciones.length > 0) {
      // Devuelve la info transformada del primer resultado
      return transformarRenovacion(data.arrayrenovaciones[0], data.arrayFiltrosBack || filtros, data.arrayFiltrosBackPymes);
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const FetchRenovacionItem = async (idRenovacion) => {
  var url = `${urlListarRenovacion}${idRenovacion}`;
  try {
    const data = await httpClient.get(url);
    if (data && data.transaccion && data.renovacion) {
      let renovacion = data.renovacion;
      return {
        dataRenovacion: renovacion
      };

    } else {
      return null;
    }
  } catch (e) {
    return null;
  }
}

export const obtenerCarritoPorIdCarrito = async (idCarrito) => {
  // Construye la URL de búsqueda usando el idCarrito
  var url = `${urlListarCarrito}${idCarrito}`;
  try {
    const data = await httpClient.get(url);
    if (data && data.transaccion == true) {
      // Devuelve la info transformada del primer resultado
      return data;
    }
    return null;
  } catch (error) {
    return null;
  }
};



export const validarBotonRecotizar = (renovacion) => {

  if (renovacion.estado != ESTADOS_RENOVACION.VENCIDAS) return false

  if (renovacion.productoExterno) return false

  if (renovacion.aplicarRecompra) return false


  const ultimaFecha = moment(convertirTimestampAFecha(obtenerUltimafechaRecotizar(renovacion))).startOf('days')


  const diasTranscurridos = fechaActual.diff(moment(ultimaFecha), 'days');

  return diasTranscurridos <= 30;
};




export const validarBotonContinuar = (renovacion) => {

  // Validación LOB para ramo PYMES
  if (renovacion.ramo === 'PYMES' && COMENTARIO_LOB_BLOQUEADOS.includes((renovacion.comentarioLob || '').toLowerCase())) {
    return false;
  }

  // Estados no válidos para botón Continuar
  const estadosNoValidos = [
    ESTADOS_RENOVACION.ADS
  ];

  if (estadosNoValidos.includes(renovacion.estado)) {
    return false;
  }





  const { estado, fechaCaducidadCobP } = renovacion

  const fechaCaducidadCobProvisional = moment(convertirTimestampAFecha(fechaCaducidadCobP)).startOf('day');

  const fechaCarta = moment(convertirTimestampAFecha(renovacion.fechaCaducidadNoS)).startOf('day');

  const ultimaFecha = moment(convertirTimestampAFecha(obtenerUltimafecha(renovacion))).startOf('days')





  if (estado == ESTADOS_RENOVACION.PROVISIONAL_SOLICITADA && renovacionTieneCarrito(renovacion) && fechaActual.isSameOrBefore(fechaCaducidadCobProvisional)) {
    return true
  }


  if (estado == ESTADOS_RENOVACION.NO_SINIESTROS_FIRMADA && renovacionTieneCarrito(renovacion) && fechaActual.isSameOrBefore(fechaCarta)) {
    return true
  }


  if (estado == ESTADOS_RENOVACION.NO_SINIESTROS_SOLICITADA && renovacionTieneCarrito(renovacion) && fechaActual.isSameOrBefore(ultimaFecha)) {
    return true
  }

  if ((estado == ESTADOS_RENOVACION.EN_PROCESO || renovacion.estado == ESTADOS_RENOVACION.NO_RENOVABLE) && renovacionTieneCarrito(renovacion) && fechaActual.isSameOrBefore(ultimaFecha)) {
    return true
  } else {
    return false
  }



  return renovacion.estado == ESTADOS_RENOVACION.EN_PROCESO || (renovacion.estado == ESTADOS_RENOVACION.NO_RENOVABLE && (renovacion.reIdCarrito != '' || renovacion.reIdCarrito != '-'))
}

export const validarCoberturaProvisional = (renovacion) => {




  if (renovacion == {}) {
    return false
  }

  // Validación LOB para ramo PYMES
  if (renovacion.ramo === 'PYMES' && COMENTARIO_LOB_BLOQUEADOS.includes((renovacion.comentarioLob || '').toLowerCase())) {
    return false;
  }

  // Estados no válidos para cobertura provisional
  const estadosNoValidos = [
    ESTADOS_RENOVACION.VENCIDAS,
    ESTADOS_RENOVACION.PROVISIONAL_SOLICITADA,
    ESTADOS_RENOVACION.EN_PROCESO_2,
    ESTADOS_RENOVACION.NO_SINIESTROS_SOLICITADA,
    ESTADOS_RENOVACION.NO_SINIESTROS_FIRMADA,
    ESTADOS_RENOVACION.NO_RENOVABLE,
    ESTADOS_RENOVACION.FVC,
    ESTADOS_RENOVACION.FVP,
    ESTADOS_RENOVACION.ES,
    ESTADOS_RENOVACION.RENOVADA,
    ESTADOS_RENOVACION.ADS,
    ESTADOS_RENOVACION.EMISION_TRADICIONAL
  ];

  if (estadosNoValidos.includes(renovacion.estado)) {
    return false;
  }


  if (renovacion.aplicarRecompra) {
    return false
  }


  let numeroDias = parseInt(renovacion.filtros[1].reValores[0].reValor, 10);
  const fechaCaducidad = moment(renovacion.mesCaducidad).startOf('day');
  const fechaLimite = fechaCaducidad.clone().subtract(numeroDias, 'days');



  if (renovacion.estado == ESTADOS_RENOVACION.POR_RENOVAR || renovacion.estado == ESTADOS_RENOVACION.EN_PROCESO) {

    return fechaActual.isSameOrBefore(fechaCaducidad) && fechaActual.isSameOrAfter(fechaLimite)
  }

  const validacion = fechaActual.isSameOrAfter(fechaLimite);


  return validacion;
};




export const renovacionTieneCarrito = (renovacion) => {
  return /^[a-fA-F0-9]{24}$/.test(renovacion.reIdCarrito);
}


export const validarBotonCarta = (renovacion) => {

  // Validación LOB para ramo PYMES
  if (renovacion.ramo === 'PYMES' && COMENTARIO_LOB_BLOQUEADOS.includes((renovacion.comentarioLob || '').toLowerCase())) {
    return false;
  }

  if (renovacion.aplicarRecompra) {
    return false
  }
  //  return true
  if (renovacion.estado === ESTADOS_RENOVACION.PROVISIONAL_SOLICITADA) {



    if (renovacion.aplicarRecompra) {
      return false
    }

    const numeroDiasPosteriores = parseInt(renovacion.filtros[2].reValores[0].reValor, 10);

    const fechaCaducidadCobProvisional = moment(convertirTimestampAFecha(renovacion.fechaCaducidadCobP)).startOf('day');


    const fechaLimiteInferiorCarta = fechaCaducidadCobProvisional.clone().add(numeroDiasPosteriores, 'days')


    const validacion = fechaActual.isSameOrAfter(fechaCaducidadCobProvisional) && fechaActual.isSameOrBefore(fechaLimiteInferiorCarta)


    return validacion



  }


  if (renovacion.estado == ESTADOS_RENOVACION.POR_RENOVAR || renovacion.estado == ESTADOS_RENOVACION.EN_PROCESO) {

    const numeroDias = parseInt(renovacion.filtros[2].reValores[0].reValor)


    const fechaCaducidad = moment(renovacion.mesCaducidad).startOf('day');
    const fechaCaducidadNueva = fechaCaducidad.clone().add(numeroDias, 'days')




    return fechaActual.isAfter(fechaCaducidad) && fechaActual.isSameOrBefore(fechaCaducidadNueva)
  }

  if (renovacion.estado == ESTADOS_RENOVACION.NO_SINIESTROS_SOLICITADA) {
    return true
  }

  // Por defecto, no se permite
  return false;
};

const obtenerUltimafecha = (renovacion) => {

  let fechaCaducidad = renovacion.reDatosProducto.reFechaCaducidad

  if (renovacion.fechaCaducidadCobP) {

    fechaCaducidad = renovacion.fechaCaducidadCobP

  }

  if (renovacion.fechaCaducidadNoS) {

    fechaCaducidad = renovacion.fechaCaducidadNoS
  }

  return fechaCaducidad


}

const obtenerUltimafechaRecotizar = (renovacion) => {

  let fechaCaducidad = renovacion.reDatosProducto.reFechaCaducidad

  if (renovacion.fechaCaducidadCobP) {

    fechaCaducidad = renovacion.fechaCaducidadCobP

  }

  if (renovacion.fechaCaducidadNoS) {

    fechaCaducidad = renovacion.fechaCaducidadNoS
  }

  return fechaCaducidad


}

export const obtenerFechaCobertura = (renovacion, filtros) => {


  const numeroDias = parseInt(filtros[1].reValores[1].reValor, 10);



  try {
    return moment(convertirTimestampAFecha(renovacion.fechaCaducidadCobP)).startOf('days').format('YYYY-MM-DD')
  } catch (error) {
    return ''
  }



}

export const obtenerFechaCarta = (renovacion, filtros) => {


  const numeroDias = parseInt(filtros[1].reValores[1].reValor, 10);


  try {
    return moment(convertirTimestampAFecha(renovacion.fechaCaducidadNoS)).startOf('days').format('YYYY-MM-DD')
  } catch (error) {
    return ''
  }



}

export const validarModuloRenovacion = (tipoUsuario) => {

  // return false

  return tipoUsuario == 'broker-user' || tipoUsuario == 'asesor-user' || tipoUsuario == 'canal-user'

}


export const validarBotonFv = (renovacion) => {

  return renovacion.estado == ESTADOS_RENOVACION.FVP
}


export const validarBotonRenovar = (renovacion) => {


  // Validación LOB para ramo PYMES
  if (renovacion.ramo === 'PYMES' && COMENTARIO_LOB_BLOQUEADOS.includes((renovacion.comentarioLob || '').toLowerCase())) {
    return false;
  }

  // Validación LOB: permitir modificar condiciones en estado POR_RENOVAR
  if (renovacion.ramo === 'PYMES' && renovacion.estado === ESTADOS_RENOVACION.POR_RENOVAR && (renovacion.comentarioLob || '').toLowerCase() === COMENTARIO_LOB.MODIFICAR_CONDICIONES) {
    return true;
  }


  // Estados que no permiten renovar
  const estadosNoPermitidos = [ESTADOS_RENOVACION.EN_PROCESO, ESTADOS_RENOVACION.VENCIDAS, ESTADOS_RENOVACION.EN_PROCESO_2, ESTADOS_RENOVACION.NO_SINIESTROS_SOLICITADA, ESTADOS_RENOVACION.NO_RENOVABLE, ESTADOS_RENOVACION.FVP, ESTADOS_RENOVACION.FVC, ESTADOS_RENOVACION.ES, ESTADOS_RENOVACION.RENOVADA, ESTADOS_RENOVACION.ADS, ESTADOS_RENOVACION.EMISION_TRADICIONAL];
  if (estadosNoPermitidos.includes(renovacion.estado)) {
    return false;
  }

  if (renovacion.aplicarRecompra) {
    return false
  }

  const fechaCaducidad = moment(renovacion.mesCaducidad).startOf('day');
  const fechaCobertura = moment(convertirTimestampAFecha(renovacion.fechaCaducidadCobP)).startOf('day');
  const fechaLimiteCobertura = fechaCobertura.clone()

  // Validación para estado ESTADOS_RENOVACION.NO_SINIESTROS_FIRMADA
  if (renovacion.estado === ESTADOS_RENOVACION.NO_SINIESTROS_FIRMADA) {

    const fechaCarta = moment(convertirTimestampAFecha(renovacion.fechaCaducidadNoS)).startOf('day');



    return fechaActual.isSameOrBefore(fechaCarta) && !renovacionTieneCarrito(renovacion);
  }


  // Validación para estado ESTADOS_RENOVACION.PROVISIONAL_SOLICITADA
  if (renovacion.estado === ESTADOS_RENOVACION.PROVISIONAL_SOLICITADA) {




    return fechaActual.isSameOrBefore(fechaLimiteCobertura) && !renovacionTieneCarrito(renovacion);
  }

  console.log('renovacionAnalizar', fechaCaducidad.calendar(), renovacion.mesCaducidad)

  // Validación general
  return fechaActual.isSameOrBefore(fechaCaducidad);
};


export const validarBotonRecompra = (renovacion) => {
  // Estados que no permiten renovar
  const estadosPermitidos = [ESTADOS_RENOVACION.POR_RENOVAR];
  if (!estadosPermitidos.includes(renovacion.estado)) {
    return false;
  }

  if (!renovacion.aplicarRecompra) {


    return false
  }


  const fechaCaducidad = moment(renovacion.mesCaducidad).startOf('day');

  // Validación para estado ESTADOS_RENOVACION.NO_SINIESTROS_FIRMADA
  if (renovacion.estado === ESTADOS_RENOVACION.NO_SINIESTROS_FIRMADA) {
    const numeroDias = parseInt(renovacion.filtros[1].reValores[1].reValor, 10);
    const fechaCobertura = moment(convertirTimestampAFecha(renovacion.fechaCaducidadCobP)).startOf('day');
    const fechaLimiteCobertura = fechaCobertura.clone().add(numeroDias, 'days');

    return fechaActual.isSameOrBefore(fechaLimiteCobertura);
  }

  // Validación para estado ESTADOS_RENOVACION.PROVISIONAL_SOLICITADA
  if (renovacion.estado === ESTADOS_RENOVACION.PROVISIONAL_SOLICITADA) {
    return fechaActual.isSameOrBefore(fechaCaducidad);
  }

  // Validación general
  return fechaActual.isSameOrBefore(fechaCaducidad);
};

export const obtenerSumaAsegurada = (renovacion) => {



  if (renovacion && renovacion.reDatosProducto && renovacion.reDatosProducto.reDatosVehiculo && Array.isArray(renovacion.reDatosProducto.reDatosVehiculo)) {
    let datosVehiculo = renovacion.reDatosProducto.reDatosVehiculo

    let valorSuma = 0

    datosVehiculo.forEach(element => {

      valorSuma += parseFloat(element.reValorAsegurado)

    });
    return formatearNumero(valorSuma)

  } else {
    return 0
  }
}

export const FetchListadoRenovaciones = (param, ambiente, id = null, rangoFecha, filtros = {
  "color": "",
  "marca": ""
}, ramo = 'TODAS') => async (dispatch) => {
  let ramoUrl = ramo;
  if (ramo === 'VEHICULOS PERSONALES' || ramo === 'TODAS') ramoUrl = 'VEHÍCULOS';

  var url = `${urlListarRenovaciones}${param}&ambiente=${ambiente}&ramo=${ramoUrl}`;
  dispatch(listaRenovacionesIsLoading(true));
  await httpClient.post(url,
    {
      rangoFecha: rangoFecha ? rangoFecha : null,
      "filtrosAtributos": filtros ? {
        "reDatosPagador.reIdentificacion": filtros.identificacionContratante,
        "reDatosContratante.reEmail": filtros.emailContratante,
        "reDatosPagador.reNombre1": filtros.nombreContratante,
        "reDatosProducto.reDatosVehiculo.rePlaca": filtros.placa,
        "reDatosProducto.reDatosVehiculo.reMarca": filtros.marca,
        "reDatosProducto.reDatosVehiculo.reModelo": filtros.modelo,
        "reDatosProducto.reProducto": filtros.polDescripcionSeguro,
        "reNumPoliza": filtros.numeroPolizaEmision,
        "reCarritoContador": filtros.reCarritoContador,
        "reDatosBroker.rebrokersucursal": filtros.sucursal,
        "reEstadoRenovacion": filtros.reEstadoRenovacion
      } : {}
    
  })


    .then((data) => {
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (e) {
          console.error("Error parseando data a JSON", e);
        }
      }

      if (data.arrayrenovaciones) {
        if (data.arrayrenovaciones !== undefined) {

          let datostransformados = data.arrayrenovacionesTransformada || transformarDatos(data.arrayrenovaciones, data.arrayFiltrosBack, data.arrayFiltrosBackPymes);

          if (data.arrayrenovacionesTransformada) {
            datostransformados.forEach(dato => {
              dato.filtros = (dato.reDatosProducto && (dato.reDatosProducto.reRamo === 'PYMES' || dato.reDatosProducto.reRamoProducto === 'PYMES') && data.arrayFiltrosBackPymes) ? data.arrayFiltrosBackPymes : data.arrayFiltrosBack;
              dato.fechaCobertura = dato.fechaCaducidadCobP ? obtenerFechaCobertura(dato, dato.filtros) : '';
              dato.fechaCarta = dato.fechaCaducidadNoS ? obtenerFechaCarta(dato, dato.filtros) : '';

              if (dato.mesCaducidad && typeof dato.mesCaducidad === 'number' || typeof dato.mesCaducidad === 'string' && !isNaN(Number(dato.mesCaducidad))) {
                dato.mesCaducidad = moment(parseInt(dato.mesCaducidad)).format('YYYY-MM-DD');
              }
              if (dato.fechaCreacion && typeof dato.fechaCreacion === 'number' || typeof dato.fechaCreacion === 'string' && !isNaN(Number(dato.fechaCreacion))) {
                dato.fechaCreacion = moment(parseInt(dato.fechaCreacion)).format('YYYY-MM-DD');
              }

              if (!validarBotonCarta(dato) && !validarBotonContinuar(dato) && !validarBotonRenovar(dato) && !validarBotonRecompra(dato) && !validarCoberturaProvisional(dato) &&
                dato.estado != ESTADOS_RENOVACION.NO_SINIESTROS_SOLICITADA && dato.estado != ESTADOS_RENOVACION.EN_PROCESO_2 &&
                dato.estado != ESTADOS_RENOVACION.NO_RENOVABLE && dato.estado != ESTADOS_RENOVACION.FVP && dato.estado != ESTADOS_RENOVACION.FVC &&
                dato.estado != ESTADOS_RENOVACION.ES && dato.estado != ESTADOS_RENOVACION.RENOVADA && dato.estado != ESTADOS_RENOVACION.EMISION_TRADICIONAL &&
                dato.polDescripcionSeguroVer != 'KÍLOMETROS PAQUETE' &&
                !(dato.ramo === 'PYMES' && (dato.comentarioLob || '').toLowerCase() === COMENTARIO_LOB.MODIFICAR_CONDICIONES)
              ) {
                dato.estado = ESTADOS_RENOVACION.VENCIDAS;
                dato.estadoVer = dato.aplicarRecompra ? 'Recompra vencida' : 'Renovación vencida';
              }
              if (dato.ramo === 'PYMES' && COMENTARIO_LOB_BLOQUEADOS.includes((dato.comentarioLob || '').toLowerCase())) {
                dato.estado = ESTADOS_RENOVACION.NO_RENOVABLE;
                dato.estadoVer = 'No renovable';
              }
            });
          }

          const resultado = datostransformados.reduce((acc, curr) => {
            const index = acc.findIndex(item => item.id === curr.reEstadoRenovacionCod);
            if (index !== -1) {
              acc[index].value += 1;
            } else {
              acc.push({
                name: curr.estadoVer,
                id: curr.estado,
                value: 1
              });
            }
            return acc;
          }, []);






          var filtros = [{
            "name": "Todas",
            "id": "todas",
            "value": data.arrayrenovaciones.length
          }


          ]



          resultado.forEach(element => {
            filtros.push(element)

          });

          const uniqueArray = [...new Map(filtros.map(item => [item.name, item])).values()];

          dispatch(limpiarListaRenovaciones());





          dispatch(setListaRenovaciones(datostransformados));
          dispatch(setListaEstados(uniqueArray));


          if (id) {




            let renovacionSeleccionada = {
              alldata: data.arrayrenovaciones.find(item => {
                const itemId = typeof item._id === 'object' && item._id && item._id.$oid ? item._id.$oid : item._id;
                return itemId == id;
              }),
              dataTransformada: datostransformados.find(item => {
                const itemId = typeof item.id === 'object' && item.id && item.id.$oid ? item.id.$oid : item.id;
                return itemId == id;
              })
            }

            dispatch(listaRenovacionesIsLoading(false));
            dispatch(setRenovacionSeleccionada(renovacionSeleccionada))
          }
        } else {
          dispatch(limpiarListaRenovaciones());
        }
      } else {
        dispatch(listaRenovacionesHasErrored());
        dispatch(setListaRenovaciones([]));
        dispatch(setListaEstados([]));
      }
    })
    .catch((response) => {
      dispatch(listaRenovacionesHasErrored());
      dispatch(setListaRenovaciones([]));
      dispatch(setListaEstados([]));
    });
};

export const FetchExportarEccel = (param, ambiente, id = null, rangoFecha, filtros = {
  "color": "",
  "marca": ""
}, history, ramo = 'TODAS') => async (dispatch) => {
  let ramoUrl = ramo;
  if (ramo === 'VEHICULOS PERSONALES' || ramo === 'TODAS') ramoUrl = 'VEHÍCULOS';

  var url = `${urlExportarExcel}${param}&ambiente=${ambiente}&ramo=${ramoUrl}`;
  dispatch(listaRenovacionesIsLoading(true));
  await httpClient.post(url,
    {
      rangoFecha: rangoFecha ? rangoFecha : "10-10-2000 | 10-10-2026",
      "filtrosAtributos": filtros ? {
        "reDatosContratante.reIdentificacion": filtros.identificacionContratante,
        "reDatosPagador.reNombre1": filtros.nombreContratante,
        "reDatosProducto.reDatosVehiculo.rePlaca": filtros.placa,
        "reDatosProducto.reDatosVehiculo.reMarca": filtros.marca,
        "reDatosProducto.reDatosVehiculo.reModelo": filtros.modelo,
        "reDatosProducto.reProducto": filtros.polDescripcionSeguro,
        "reNumPoliza": filtros.numeroPolizaEmision,
        "reCorePoliza": filtros.numeroCompra,
        "reDatosBroker.rebrokersucursal": filtros.sucursal,
        "reEstadoRenovacion": filtros.reEstadoRenovacion
      } : {}
    
  })


    .then((data) => {

      if (data.transaccion) {

        window.open(data.url, '_blank');



      }

      dispatch(listaRenovacionesIsLoading(false));
    })
    .catch((response) => {
      dispatch(listaRenovacionesHasErrored());
      dispatch(setListaRenovaciones([]));
      dispatch(setListaEstados([]));
    });
};

/**
 * Obtiene el nombre del contratante. Si reDatosContratante no tiene datos,
 * usa reDatosAsegurado como fallback (misma lógica que la pantalla de detalle de renovación).
 */
function obtenerNombreContratante(dato) {
  // Intentar desde reDatosContratante (lógica original)
  let nombre = '';
  if (dato && dato.reDatosContratante && dato.reDatosContratante.reNombre1 && dato.reDatosContratante.reNombre1 !== '-') {
    nombre = `${dato.reDatosContratante.reNombre1} ${dato.reDatosContratante.reApellido1 ? dato.reDatosContratante.reApellido1 : ''}`.trim();
  } else if (dato && dato.reDatosContratante && dato.reDatosContratante.reRazonSocial) {
    nombre = dato.reDatosContratante.reRazonSocial;
  } else if (dato && dato.reDatosContratante && dato.reDatosContratante.reNombre) {
    nombre = dato.reDatosContratante.reNombre;
  }

  // Fallback: usar reDatosAsegurado si el nombre queda vacío (ej: PYMES donde no existe reDatosContratante)
  if (!nombre && dato && dato.reDatosAsegurado) {
    const aseg = dato.reDatosAsegurado;
    nombre = aseg.reRazonSocial || (
      (aseg.reNombre1 ? aseg.reNombre1 + ' ' : '') +
      (aseg.reNombre2 ? aseg.reNombre2 + ' ' : '') +
      (aseg.reApellido1 ? aseg.reApellido1 + ' ' : '') +
      (aseg.reApellido2 ? aseg.reApellido2 : '')
    ).trim();
  }

  return nombre || '';
}

function transformarDatos(arrayDatos, filtros, filtrosPymes) {



  return arrayDatos.map((dato, index) => {
    try {
      let sumaAsegurada = obtenerSumaAsegurada(dato)
      // Validar si la fecha de caducidad está definida
      const fechaCaducidad = dato && dato.reDatosProducto && dato.reDatosProducto.reFechaCaducidad
        ? new moment(parseInt(dato.reDatosProducto.reFechaCaducidad)).format('YYYY-MM-DD')
        : null;

      const fechaCreacion = dato && dato.reDatosProducto && dato.reDatosProducto.reFechaInicio
        ? new moment(parseInt(dato.reDatosProducto.reFechaInicio)).format('YYYY-MM-DD')
        : null;

      // Si no hay fecha de caducidad, asignamos un valor por defecto
      const mesCaducidad = dato && dato.reDatosProducto && dato.reDatosProducto.reFechaCaducidad
        ? dato.reDatosProducto.reFechaCaducidad
        : '';

      const marca = dato && dato.reDatosProducto && dato.reDatosProducto.reDatosVehiculo && dato.reDatosProducto.reDatosVehiculo.reMarca
        ? dato.reDatosProducto.reDatosVehiculo.reMarca
        : ''; // Validar marca del vehículo
      const placa = dato && dato.reDatosProducto && dato.reDatosProducto.reDatosVehiculo && dato.reDatosProducto.reDatosVehiculo[0] && dato.reDatosProducto.reDatosVehiculo[0].rePlaca
        ? dato.reDatosProducto.reDatosVehiculo.rePlaca
        : ''; // Validar placa

      const vehiculoAll = dato && dato.reDatosProducto && dato.reDatosProducto.reDatosVehiculo
        ? dato.reDatosProducto.reDatosVehiculo
        : []; // Validar placa
      const anio = dato && dato.reDatosProducto && dato.reDatosProducto.reDatosVehiculo && dato.reDatosProducto.reDatosVehiculo.reAño
        ? dato.reDatosProducto.reDatosVehiculo.reAño
        : ''; // Validar año
      const modelo = dato && dato.reDatosProducto && dato.reDatosProducto.reDatosVehiculo && dato.reDatosProducto.reDatosVehiculo.reModelo
        ? dato.reDatosProducto.reDatosVehiculo.reModelo
        : ''; // Validar modelo

      const vehiculo = `
       <b>Placa:</b> ${placa}
    <b>Marca:</b> ${marca}
    <b>Modelo:</b> ${modelo}
    <b>Año:</b> ${anio}
  `;

    let datoModificado = {
      ...dato,
      filtros: (dato.reDatosProducto && (dato.reDatosProducto.reRamo === 'PYMES' || dato.reDatosProducto.reRamoProducto === 'PYMES') && filtrosPymes) ? filtrosPymes : filtros,
      id: dato && dato._id ? dato._id : '', // Validar si _id existe
      contador: index + 1,
      reNuevosValores: dato.reNuevosValores,
      fechaCobertura: dato.fechaCaducidadCobP ? obtenerFechaCobertura(dato, filtros) : '',
      fechaCarta: dato.fechaCaducidadNoS ? obtenerFechaCarta(dato, filtros) : '',
      noItems: dato && dato.reDatosProducto && dato.reDatosProducto.reDatosVehiculo && dato.reDatosProducto.reDatosVehiculo[0]
        ? dato.reDatosProducto.reDatosVehiculo.length
        : 1,
      fechaCreacion: fechaCreacion,
      nombreContratante: obtenerNombreContratante(dato), // Obtener nombre con fallback a reDatosAsegurado para PYMES
      polIdentificacionesAsegurados: dato && dato.reDatosContratante && dato.reDatosContratante.reIdentificacion,
      emailContratante: dato && dato.reDatosContratante && dato.reDatosContratante.reEmail
        ? dato.reDatosContratante.reEmail
        : '', // Validar identificación
      polDescripcionRamo: dato && dato.reDatosProducto
        ? (dato.reDatosProducto.reRamoProducto === 'PYMES' ? 'PYMES' : (dato.reDatosProducto.reRamo || ''))
        : '', // Validar ramo (reRamoProducto tiene prioridad para PYMES)
      polDescripcionSeguroVer: dato.reDatosProducto.reProducto,
      noPortal: dato.reDatosProducto.productoNoPortal,
      polDescripcionSeguro: dato && dato.aplicarRecompra
        ? PRODUCTOS.KILOMETROS_PAQUETE
        : dato && dato.reDatosProducto && dato.reDatosProducto.esPractiAuto ? PRODUCTOS.PRACTIAUTO
          : PRODUCTOS.AIG_AUTO,
      numeroPolizaEmision: dato && dato.reNumPoliza ? dato.reNumPoliza : '', // Validar número de póliza
      numeroCompra: dato && dato.reCarritoContador ? dato.reCarritoContador : '', // Validar corePóliza
      traMetodoPago: 'No especificado', // Ajusta si tienes el dato en otro campo
      total: dato && dato.reDatosProducto && dato.reDatosProducto.rePrimaNeta && dato.reDatosProducto.reScoring
        ? parseFloat(dato.reDatosProducto.rePrimaNeta) + parseFloat(dato.reDatosProducto.reScoring)
        : 0, // Validar prima final

      primaNeta: dato && dato.reDatosProducto && dato.reDatosProducto.rePrimaNeta
        ? parseFloat(dato.reDatosProducto.rePrimaNeta)
        : 0, // Validar prima final
      detalles: "Ver detalles", // Ajusta según sea necesario
      estado: dato && dato.reEstadoRenovacionCod ? dato.reEstadoRenovacionCod : '', // Validar estado
      estadoVer: dato && dato.reEstadoRenovacion ? dato.reEstadoRenovacion : '', // Validar estado
      vehiculo: vehiculo,
      reUrlFormulario: dato.reUrlFormulario,
      marca: dato && dato.reDatosProducto && dato.reDatosProducto.reDatosVehiculo && dato.reDatosProducto.reDatosVehiculo[0] && dato.reDatosProducto.reDatosVehiculo[0].reMarca
        ? dato.reDatosProducto.reDatosVehiculo[0].reMarca
        : '', // Validar marca del vehículo
      placa: dato && dato.reDatosProducto && dato.reDatosProducto.reDatosVehiculo && dato.reDatosProducto.reDatosVehiculo[0] && dato.reDatosProducto.reDatosVehiculo[0].rePlaca
        ? dato.reDatosProducto.reDatosVehiculo[0].rePlaca
        : '', // Validar placa
      anio: dato && dato.reDatosProducto && dato.reDatosProducto.reDatosVehiculo && dato.reDatosProducto.reDatosVehiculo[0] && dato.reDatosProducto.reDatosVehiculo[0].reAño
        ? dato.reDatosProducto.reDatosVehiculo[0].reAño
        : '', // Validar año
      modelo: dato && dato.reDatosProducto && dato.reDatosProducto.reDatosVehiculo && dato.reDatosProducto.reDatosVehiculo[0] && dato.reDatosProducto.reDatosVehiculo[0].reModelo
        ? dato.reDatosProducto.reDatosVehiculo[0].reModelo
        : '', // Validar modelo
      estadoVer: dato && dato.reEstadoRenovacion
        ? dato.reEstadoRenovacion == ESTADOS_RENOVACION.NO_RENOVADAS ? 'NO RENOVABLES' : dato.reEstadoRenovacion.replace('_', ' ')
        : '',
      aplicarRecompra: dato && dato.aplicarRecompra ? dato.aplicarRecompra : false, // Validar aplicar recompra
      reidPoliza: dato && dato.reidPoliza ? dato.reidPoliza : '', // Validar reidPoliza
      esRecotizacion: dato.esRecotizacion,
      sucursal: dato && dato.reDatosBroker && dato.reDatosBroker.rebrokersucursal
        ? dato.reDatosBroker.rebrokersucursal
        : '', // Validar sucursal
      prima: dato && dato.rePrimaFinal ? dato.rePrimaFinal : 0, // Validar prima
      mesCaducidad: fechaCaducidad, // Usar la fecha formateada o valor nulo si no existe,
      estadoFormVinculacion: 'Formulario Completado y Firmado',
      emailContratante: dato.reDatosContratante.reEmail,
      sumaAsegurada: sumaAsegurada,
      reIdCarrito: dato.reIdCarrito,
      procesadoCorreoCobP: dato.procesadoCorreoCobP,
      procesadoCorreoNoS: dato.procesadoCorreoNoS,
      mensajeNoRenovables: dato.mensajeNoRenovables ? dato.mensajeNoRenovables : ' No cumple con los requisitos establecidos para la renovación',
      fechaCaducidadCobP: dato.fechaCaducidadCobP,
      vehiculoAll: vehiculoAll,
      fechaCaducidadNoS: dato.fechaCaducidadNoS,
      productoExterno: dato.productoExterno,
      ramo: (dato.reDatosProducto.reRamoProducto === 'PYMES') ? 'PYMES' : dato.reDatosProducto.reRamo,
      comentarioLob: (dato.reDatosProducto && dato.reDatosProducto.reCondicionesRenovacion) ? dato.reDatosProducto.reCondicionesRenovacion : (dato.comentarioLob || ''),
      reProductoNuevo: dato.reDatosProducto.reProductoNuevo ? dato.reDatosProducto.reProductoNuevo : 'comparador',
      impuestos: {
        "totalcarrito": "1829.28",
        "prima_neta_anual_full_cobertura": "1,524.70",
        "prima_neta_anual_TPL": "0.00",
        "total_lost_prima_anual": "0.00",
        "super_bancos_TPL": "0.00",
        "super_bancos_Full_Cobertura": "53.36",
        "super_bancos_total_loss": "0.00",
        "seguro_campesino_TPL": "0.00",
        "seguro_campesino_Full_Cobertura": "7.62",
        "seguro_campesino_total_loss": "0.00",
        "derecho_emision_TPL": "0.00",
        "derecho_emision_Full_Cobertura": "5.00",
        "derecho_emision_total_loss": "0.00",
        "iva_TPL": "0.00",
        "iva_Full_Cobertura": "238.60",
        "iva_Total_Loss": "0.00",
        "primaTotal_TPL": "0.00",
        "primaTotal_Total_Loss": "0.00",
        "totalImpuestos": "304.58"
      },
      multiple: dato.reDatosProducto.multiple,
      siniestralidad1: dato && dato.reDatosPagador && dato.reDatosPagador.rePjeSiniestralidad,
      siniestralidad2: dato && dato.reDatosPagador && dato.reDatosPagador.rePjeSiniestralidad,

      };

      if (
        !validarBotonCarta(datoModificado) &&
        !validarBotonContinuar(datoModificado) &&
        !validarBotonRenovar(datoModificado) &&
        !validarBotonRecompra(datoModificado) &&
        !validarCoberturaProvisional(datoModificado) &&
        datoModificado.estado != ESTADOS_RENOVACION.NO_SINIESTROS_SOLICITADA &&
        //      datoModificado.estado != ESTADOS_RENOVACION.NO_SINIESTROS_FIRMADA &&
        datoModificado.estado != ESTADOS_RENOVACION.EN_PROCESO_2 &&
        datoModificado.estado != ESTADOS_RENOVACION.NO_RENOVABLE &&
        datoModificado.estado != ESTADOS_RENOVACION.FVP &&
        datoModificado.estado != ESTADOS_RENOVACION.FVC &&
        datoModificado.estado != ESTADOS_RENOVACION.ES &&
        datoModificado.estado != ESTADOS_RENOVACION.RENOVADA &&
        datoModificado.estado != ESTADOS_RENOVACION.EMISION_TRADICIONAL &&
        datoModificado.polDescripcionSeguroVer != 'KÍLOMETROS PAQUETE' &&
        datoModificado.polDescripcionSeguroVer != 'KÍLOMETROS PAQUETE'

    ) {
      datoModificado.estado = ESTADOS_RENOVACION.VENCIDAS
      datoModificado.estadoVer = datoModificado.aplicarRecompra ? 'Recompra vencida' : 'Renovación vencida'
    }

    // Sobreescribir estado a No renovable cuando LOB bloquea la póliza PYMES
    if (datoModificado.ramo === 'PYMES' && COMENTARIO_LOB_BLOQUEADOS.includes((datoModificado.comentarioLob || '').toLowerCase())) {
      datoModificado.estado = ESTADOS_RENOVACION.NO_RENOVABLE
      datoModificado.estadoVer = 'No renovable'
    }



      return datoModificado;
    } catch (e) {
      console.error("Error al transformar el registro de renovación individual en el index " + index, e);
      return null;
    }
  }).filter(Boolean);
}


export const validarPolizaVencida = (datoModificado) => {

  if (
    !validarBotonCarta(datoModificado) &&
    validarBotonContinuar(datoModificado) &&
    !validarBotonRenovar(datoModificado) &&
    !validarBotonRecompra(datoModificado) &&
    !validarCoberturaProvisional(datoModificado) &&
    datoModificado.estado != ESTADOS_RENOVACION.NO_SINIESTROS_SOLICITADA &&
    datoModificado.estado != ESTADOS_RENOVACION.NO_SINIESTROS_FIRMADA &&
    datoModificado.estado != ESTADOS_RENOVACION.EN_PROCESO_2 &&
    datoModificado.estado != ESTADOS_RENOVACION.NO_RENOVABLE &&
    datoModificado.polDescripcionSeguroVer != 'KÍLOMETROS PAQUETE'

  ) {
    return true;
  } else {
    return false;
  }
}

// Nueva acción de guardado de facturación PYMES adaptada a Renovaciones
export const SET_GUARDADO_FACTURACION_PYMES = "SET_GUARDADO_FACTURACION_PYMES";
export const SET_GUARDADO_FACTURACION_PYMES_LOADING = "SET_GUARDADO_FACTURACION_PYMES_LOADING";

export const setGuardadoFacturacionPymes = createAction(SET_GUARDADO_FACTURACION_PYMES);
export const setGuardadoFacturacionPymesLoading = createAction(SET_GUARDADO_FACTURACION_PYMES_LOADING);

export const guardarFacturacionPymesFetch = (param) => async (dispatch) => {
  dispatch(setGuardadoFacturacionPymesLoading(true));
  var url = `${urlGuardarFacturacionPymesRenovacion}`;

  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => response.json())
    .then((data) => {
      dispatch(setGuardadoFacturacionPymes({ respuestaFacturacion: data }));
      dispatch(setGuardadoFacturacionPymesLoading(false));
    })
    .catch(() => {
      dispatch(setGuardadoFacturacionPymes({ respuestaFacturacion: { transaccion: false, errorDescripcion: "Error de red." } }));
      dispatch(setGuardadoFacturacionPymesLoading(false));
    });
};
